<template>
  <v-select
    v-model="defaultType"
    :items="actionTypes"
    label="Action type"
    item-text="label"
    item-value="value"
  />
</template>

<script>
import { ActionType } from "../config/constants";

export default {
  name: "ActionType",
  model: {
    prop: "actionType"
  },
  props: {
    actionType: {
      type: String,
      validator: value =>
        ActionType.map(actionType => actionType.value).indexOf(value) > -1
    },
    only: {
      type: Array
    }
  },
  data() {
    return {
      defaultType: this.actionType || null
    };
  },
  computed: {
    actionTypes() {
      return this.only
        ? ActionType.filter(at => ~this.only.indexOf(at.value))
        : ActionType;
    }
  },
  watch: {
    defaultType(value) {
      this.$emit("input", value);
    }
  }
};
</script>
